export default function authenticatedPath(next_url) {
  // Build temp a element to Extract URL
  const l = document.createElement('a');

  l.href = next_url;

  const params =
    `?next=${encodeURIComponent(next_url)}` +
    `&jwt=${window.localStorage.getItem('account_access_token')}` +
    `&refresh=${window.localStorage.getItem('account_refresh_token')}` +
    `&expires=${window.localStorage.getItem('expires')}`;

  return `${l.protocol}//${l.hostname}/n/auth/redirect/${params}`;
}
